import { cn } from "@omni/utils/styles";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { useECommerceProduct } from "../../hooks/useECommerceProduct.hook";

const SoldOutStamp = () => {
    const { t } = useGranite();
    const { isBoxSoldOut } = useECommerceProduct();

    if (!isBoxSoldOut) {
        return null;
    }
    return (
        <div
            className={cn(
                "tw:absolute tw:left-0 tw:top-0 tw:h-full tw:w-full tw:layer-base/[4] tw:flex tw:justify-center tw:items-center",
                "tw:text-center tw:bg-background/52"
            )}
        >
            <div className={cn("tw:-rotate-45")}>
                <span
                    className={cn(
                        "tw:bg-background tw:border-4 tw:border-danger tw:text-danger tw:text-[1.7em] tw:font-extrabold tw:p-2.5 tw:uppercase"
                    )}
                >
                    {t("ecommerce.box.soldout")}
                </span>
            </div>
        </div>
    );
};

export { SoldOutStamp };
